@use "../../../sass/global/global" as *;

/* stylelint-disable max-nesting-depth, selector-max-compound-selectors, selector-no-qualifying-type  */
.ux-iws-navigation-meta {
    display: flex;
    flex-direction: row;

    @media only screen and (min-width: $desktop-s-navigation-100) {
        width: fit-content;
        padding-right: 20px;
    }

    ux-iws-async-html {
        .ux-iws-nav__meta-container-header & {
            display: none;

            &.content-loaded {
                @media only screen and (min-width: $desktop-s-navigation-100) {
                    display: flex;
                }
            }
        }
    }

    .minicart__itemsamount {
        margin-top: 0;
    }

    &__item {
        position: relative;
        display: none;

        @media only screen and (min-width: $tablet) {
            border-top: 0;
            padding-top: 0;
        }
        @media only screen and (min-width: $desktop-s-navigation-100) {
            padding-top: 6px;
            border-top: 5px solid transparent;
            display: flex;
        }

        @at-root .ux-iws-nav--empty & {
            display: flex;
            padding-top: 6px;
            border-top: 5px solid transparent;
            display: flex;
        }

        > a {
            @include font(bold);
            font-size: $size-text-smaller;
            align-items: center;
            text-transform: uppercase;
            text-decoration: none;
            line-height: normal;
            display: none;

            @media only screen and (min-width: $desktop-s-navigation-100) {
                display: flex;
            }

            @at-root .ux-iws-nav--empty & {
                display: flex;
            }
        }

        a {
            cursor: pointer;
        }

        ux-icon[name="dialog-circles"] {
            font-size: 24px;
        }

        .ux-iws-navigation-meta__link-text {
            display: none;

            .ux-iws-header__meta-container-dropdown & {
                display: flex;
            }

            @at-root .ux-iws-nav--empty & {
                display: flex;
            }

            @media only screen and (min-width: $tablet) {
                display: flex;
                white-space: nowrap;
            }
        }

        + .ux-iws-navigation-meta__item {
            margin-left: 20px;

            @media only screen and (min-width: $desktop-s-navigation-100) {
                margin-left: 25px;
            }

            @media only screen and (min-width: $desktop-l) {
                margin-left: $dim-40;
            }
        }
    }

    &__item--disabled {
        opacity: 30%;
        pointer-events: none;

        a {
            pointer-events: none;
        }

        .ux-iws-navigation-meta__link-text {
            @include font(bold);
            font-size: $size-text-smaller;
            display: flex;
            align-items: center;
            text-transform: uppercase;
            text-decoration: none;
            line-height: normal;
        }
    }

    &__item__notifications {
        .ux-iws-navigation-meta__notifications-container {
            width: 390px;

            > .ux-text-headline--small {
                text-align: center;
            }
        }

        .ux-notification-item__status-wrapper {
            display: none;
        }

        .ux-notification-item__icon-wrapper {
            align-self: flex-start;

            ux-icon {
                font-size: 45px;
            }
        }
    }

    ux-tooltip {
        position: relative;

        .button-close {
            position: absolute;
            top: 8px;
            right: 8px;
            z-index: 10;
            width: 25px;
            height: 25px;
            background: transparent;
            border: 0;
            cursor: pointer;

            ux-icon {
                pointer-events: none;
                font-size: 14px;
            }
        }
    }

    .ux-tooltip__link-item {
        @include font(bold);
        font-size: $size-text-small;
        display: flex;
        align-items: center;
        text-transform: uppercase;
        text-decoration: none;
        line-height: normal;

        &:first-child {
            margin-top: 0;
        }

        + .ux-tooltip__link-item {
            margin-top: 20px;
        }
    }

    &__item--mobile-visible {
        display: flex !important;

        > a {
            display: flex;

            .ux-iws-navigation-meta__link-text {
                @media only screen and (min-width: $tablet) {
                    display: inline-block;
                }
            }
        }
    }

    &__item--top-border {
        border-top: 5px solid $color-green;

        .ux-iws-header--mytrumpf & {
            border-top: 5px solid $color-blue-highlight-1;
        }
    }

    &__icon-box {
        display: block;
        position: relative;

        @media only screen and (min-width: $tablet) {
            margin-right: 8px;
        }

        @at-root .ux-iws-nav--empty & {
            margin-right: 8px;
        }

        > ux-icon {
            margin-right: 0;
            color: $color-grey-3;
            font-size: 20px;
            fill: currentColor;
        }
    }

    &__icon-box__notification {
        background: #bbd03a;
        font-size: 0.75rem;
        color: #fff;
        font-weight: 700;
        display: inline-block;
        margin: 0;
        position: absolute;
        top: -2px;
        right: -5px;
        padding: 2px 5px;
        border-radius: 9px;
        line-height: 12px;
    }

    input[type="search"]::-webkit-search-decoration,
    input[type="search"]::-webkit-search-cancel-button,
    input[type="search"]::-webkit-search-results-button,
    input[type="search"]::-webkit-search-results-decoration {
        -webkit-appearance: none;
    }

    &__search {
        position: relative;
        display: flex;
        align-items: center;
        cursor: pointer;

        > ux-icon {
            transition: color 0.5s ease;
            color: $color-grey-3;
            fill: currentColor;
            font-size: 20px;

            @media only screen and (min-width: $tablet) {
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
            }

            @media only screen and (min-width: $desktop-s-navigation-100) {
                /** The search icon appears visually larger than the other 20px icons - at 18px it looks harmonious. */
                font-size: 18px;
            }
        }

        > span {
            @include font(bold);
            font-size: $size-text-smaller;
            line-height: normal;
            text-transform: uppercase;
            color: $color-grey-3;
            margin-left: 26px;
            cursor: pointer;
            transition: color 0.5s ease;

            .ux-iws-header__meta-container-dropdown & {
                margin-left: 10px;
                @media only screen and (min-width: $tablet) {
                    margin-left: 23px;
                }
            }
        }

        input:not(.ux-input-field__input)[type="search"] {
            width: 0;
            height: 100%;
            padding: 0;
            border: 0;
            pointer-events: none;
            padding-left: 25px;
            padding-bottom: 3px;

            @media only screen and (min-width: $tablet) {
                padding-left: 30px;
            }
        }

        .ux-iws-navigation-meta__search__form {
            margin: 0;
            border-bottom: 1px solid $color-black;

            @media only screen and (max-width: 767px) {
                border-bottom: 0;
            }
        }

        &:hover {
            > ux-icon,
            > span {
                color: $color-black;
            }
        }
    }

    &__search__form {
        opacity: 0;
        width: 0;
    }

    &__search--open {
        cursor: default;

        .ux-iws-navigation-meta__search__form {
            opacity: 1;

            @media only screen and (min-width: $tablet) {
                width: 250px;
            }
        }

        input:not(.ux-input-field__input)[type="search"] {
            width: 100px;
            pointer-events: all;
            outline-offset: 4px;

            @media only screen and (max-width: 767px) {
                box-sizing: border-box;
                position: fixed;
                left: 0;
                right: 0;
                width: auto;
                top: 100px;
                height: 50px;
                background: white;
                padding: 20px;
                padding-left: 50px;
                padding-right: 60px;
                outline-offset: -2px;
            }

            .ux-iws-header__meta-container-dropdown & {
                width: 200px;
            }
            @media only screen and (min-width: $tablet) {
                width: 200px;
            }
        }

        /** FIXME: the search icon should not have a fixed position */
        > ux-icon {
            @media only screen and (max-width: 767px) {
                position: fixed;
                top: 115px;
                left: 15px;
                z-index: 25;
                font-size: 20px;
            }
        }

        > .ux-iws-navigation-meta__link-text {
            display: none;

            .ux-iws-header__meta-container-dropdown & {
                display: none;
            }
        }

        .ux-iws-navigation-meta__search__close {
            pointer-events: all;
            cursor: pointer;

            @media only screen and (max-width: 767px) {
                position: fixed;
                top: 124px;
                right: 20px;

                ux-icon {
                    font-size: 14px;
                }
            }

            > * {
                pointer-events: none;
            }
        }
    }

    &__search__close {
        border: 0;
        background: none;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 0;
        z-index: 8;
        pointer-events: none;

        ux-icon {
            font-size: 10px;
        }
    }

    &__see-more {
        display: flex;
        justify-content: center;
        border-top: 1px solid $color-black-3;
        padding-top: 30px;
    }

    &__notification-item {
        border-top: 1px solid $color-black-3;
        padding-top: 25px;
        padding-bottom: 25px;
        padding-right: 25px;
        display: flex;

        ux-icon {
            margin-right: 20px;
            font-size: 30px;
        }
    }

    &__sub-menu-container {
        position: absolute;
        left: 0;
        top: 2px;
        padding: 30px;
        width: 100%;
        height: calc(100% - 2px);
        z-index: 25;
        pointer-events: none;
        background: $color-white;
        opacity: 0;
        transition: transform 350ms ease-in-out;

        > ux-icon {
            position: absolute;
            top: 30px;
            right: 30px;
            cursor: pointer;
        }

        &--active {
            pointer-events: all;
            opacity: 1;
        }
    }

    &__sub-links {
        display: flex;
        flex-direction: column;
    }

    &__sub-menu__link-item {
        @include font(bold);
        font-size: $size-text-small;
        text-transform: uppercase;
        text-decoration: none;
        line-height: normal;
        margin-bottom: 30px;

        &:last-child {
            margin-bottom: 0;
        }
    }

    &__notification-error {
        ux-icon {
            color: $color-red-error;
        }

        .ux-text-headline {
            color: $color-red-error;
        }
    }

    &__notification-info {
        ux-icon {
            color: $color-black;
        }

        .ux-text-headline {
            color: $color-black;
        }
    }

    &__notification-warning {
        ux-icon,
        .ux-text-headline {
            color: #ffab00;
        }
    }

    &__notification-text__data > span + span {
        margin-left: 10px;
    }
}

/* stylelint-enable max-nesting-depth, selector-max-compound-selectors, selector-no-qualifying-type */
